import { call, put, takeLatest, takeEvery, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listReservationTypes, getReservationType } from './api';
import {
  LIST_RESERVATION_TYPES_REQUEST,
  GET_RESERVATION_TYPE_REQUEST,
  GET_RESERVATION_TYPE_SUCCESS,
  RESERVATION_TYPE_LIST_REQUESTING,
  LIST_RESERVATION_TYPES_SUCCESS,
  RESET_RESERVATION_TYPE_ISFETCHING
} from './constants';

function* list() {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_TYPE_LIST_REQUESTING });
    const response = yield call(listReservationTypes, customerId());
    yield put({ type: LIST_RESERVATION_TYPES_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_RESERVATION_TYPE_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* get(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_TYPE_LIST_REQUESTING });
    const response = yield call(getReservationType, action.slug, customerId());
    yield put({ type: GET_RESERVATION_TYPE_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    yield put({ type: RESET_RESERVATION_TYPE_ISFETCHING });
    yield call(addAPIError, error);
    return null;
  }
}

function* watchList() {
  yield takeLatest(LIST_RESERVATION_TYPES_REQUEST, list);
  yield takeEvery(GET_RESERVATION_TYPE_REQUEST, get);
}

export default function* reservationTypeSagas() {
  yield all([watchList()]);
}
